module.exports = {
  "country": "BA",
  "artist": "Dalal & Deen feat. Ana Rucner & Jala",
  "song": "Ljubav je",
  "year": "2016",
  "place": "NQ",
  "spotify": "3g6gtNcoUOObmRkQM9SjE4"
};